import { adminHttpClient } from '../../../../commons/adminHttpClient'
import { EmployeeEligibilityType } from '../../qsehra/benefitDesignState'

type EmployeeClassSelection = {
  planPeriodId: string
  employeeEligibility?: EmployeeEligibilityType
}

const sendClassSelection = (values: EmployeeClassSelection): Promise<string[]> => {
  return adminHttpClient.put('AdminDashboard/qsehra/BenefitDesign/ClassSelection', values)
}

export default sendClassSelection
